import Laptop from "../../../../src/pages/blog/portals-with-context/Laptop";
import * as React from 'react';
export default {
  Laptop,
  React
};